var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    strokeWidth: 3,
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-circle--button-delete-remove-add-circle-buttons-cross-x-mathematics-multiply-math"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 24a21 21 0 1 0 42 0 21 21 0 1 0-42 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.356 31.509c-.58-.809-.392-1.836.281-2.57.863-.94 2.34-2.506 4.73-4.939-2.39-2.432-3.867-3.999-4.73-4.939-.674-.733-.862-1.76-.281-2.57.333-.463.8-1.031 1.453-1.683.652-.652 1.22-1.12 1.683-1.453.81-.58 1.837-.393 2.57.28.94.864 2.507 2.34 4.94 4.731 2.432-2.39 3.999-3.867 4.939-4.73.733-.673 1.76-.862 2.57-.281.463.333 1.031.8 1.683 1.453.652.652 1.12 1.22 1.453 1.683.58.81.392 1.837-.281 2.57-.863.94-2.34 2.507-4.73 4.94 2.39 2.432 3.866 3.998 4.73 4.938.673.734.861 1.761.28 2.57a13.745 13.745 0 0 1-1.453 1.684c-.651.652-1.22 1.12-1.683 1.453-.809.58-1.836.392-2.57-.282-.94-.862-2.507-2.339-4.939-4.73-2.432 2.391-3.998 3.867-4.938 4.73-.734.674-1.761.862-2.57.282a13.808 13.808 0 0 1-1.684-1.453 13.745 13.745 0 0 1-1.453-1.684Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircle);
export default __webpack_public_path__ + "static/media/delete-circle.ed1612b6fe31117fe1dfb2ff07d4a0d9.svg";
export { ForwardRef as ReactComponent };